<ax-value-verified-view
  [property]="property"
  [parentProperty]="parentProperty"
  [showVerificationLabel]="showVerificationLabel"
>
  <span>{{ property | propertyDisplayValue: 'property.value.empty' }}</span>
</ax-value-verified-view>
